module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAAqUlEQVQokY2SMQoCMRQFZ3VRFPQE3kJsRGw8lsVewNbSShC8ho0WXmJZ7MQDiDAWJkuKdfVBCD9vkvcTkqkVMKFdFSpq6XeVKp0fJ9WK4KOFuafgoQXcA8Qeu+quob+Nmqk1GEeRQOvUSy8zAhZJvQLGdRV2DNRzQ/RFHabRRQMUVah8GoUrMAVOwDOE9YBl8GZ5svgCjmEGyIE50I8FibH99pjZn5/i9gYQksnwMa9oxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/alarm-missed-icon.png
// module id = RDLU
// module chunks = 1